/**
 * Ask the Worker where this visitor is. Cloudflare stamps every request with
 * the country, which the static bundle cannot see; the Worker echoes it and
 * whether that country requires consent before the pixel may load.
 * Resolves null when the Worker is unreachable or slow — the tracker then
 * falls back to the language rule rather than holding the page.
 */
export interface Geo {
  country: string | null;
  gdpr: boolean;
}

export async function geolocate(workerBase: string, timeoutMs = 1500): Promise<Geo | null> {
  const ctl = typeof AbortController === 'function' ? new AbortController() : null;
  const timer = setTimeout(() => ctl?.abort(), timeoutMs);
  try {
    const res = await fetch(`${workerBase}/geo`, { signal: ctl?.signal, credentials: 'omit' });
    if (!res.ok) return null;
    const data = (await res.json()) as Partial<Geo>;
    return { country: data.country ?? null, gdpr: !!data.gdpr };
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
